import { render } from "./LayoutContainer.vue?vue&type=template&id=eeb52fe4"
const script = {}

import "./LayoutContainer.vue?vue&type=style&index=0&id=eeb52fe4&lang=postcss"

import exportComponent from "/var/vhosts/unrisd-frontend/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__